// src/components/NumberInput.jsx
import React, { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';

const NumberInput = forwardRef((props, ref) => (
  <NumericFormat
    {...props}
    className="form-control"
    getInputRef={ref} // Use getInputRef to pass the ref
    thousandSeparator={true}
    decimalScale={0} // Ensures no decimals are shown
    allowNegative={false}
    customInput="input"
  />
));

export default NumberInput;
